module.exports = __webpack_public_path__ + "static/media/ZonaPro-Bold.ffbafd17.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Zona Pro/ZonaPro-Bold.otf
// module id = 548
// module chunks = 73